import theme from "../../themes";
import { darken } from "@material-ui/core/styles/colorManipulator";
import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  root: {
    minWidth: 320,
  },
  mainContainer: ({ isViewMode }: { isViewMode: boolean }) => ({
    border: isViewMode ? "unset" : "solid 1px #dbdbdb",
    borderRadius: 12,
    textAlign: "center",
    backgroundColor: "#f5f6f7",
  }),
  mainContainerHasError: {
    border: `solid 1px ${theme.palette.error.main} !important`,
  },
  dropzone: {
    height: 88,
    position: "relative",
    display: "grid",
    justifyContent: "center",
    alignContent: "center",
    padding: 20,

    "& + div": {
      borderTop: "solid 1px #dbdbdb",
    },
  },
  label: {
    fontWeight: 400,
    fontSize: 14,
    color: "#a1a4ac",
  },
  viewLabel: {
    color: "#383d4a",
    fontWeight: "bold",
    fontSize: 14,
    padding: "20px 20px 0",
    textAlign: "left",
  },
  textContentAndLink: {
    fontWeight: 300,
    fontSize: 14,
    color: "#68758b",
  },
  textContent: {
    marginTop: -2,
    fontSize: 10,
    color: "#77838f",
  },
  link: {
    fontWeight: 400,
    color: "#0676ed",
    "&:hover": {
      color: "#1368d8",
    },
  },
  viewModeLink: {
    fontWeight: "bold",
    color: theme.palette.info.main,
    "&:hover": {
      color: darken(theme.palette.info.main, 0.2),
      cursor: "pointer",
    },
    textDecoration: "none",
  },
  notLink: {
    fontWeight: "bold",
    color: "black",
    textDecoration: "none",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 20,
    minHeight: 39,
    "&+&": {
      borderTop: "1px solid #dbdbdb",
    },
  },
  iconInfoContainer: {
    display: "flex",
    alignItems: "center",
  },
  infoTextContainer: {
    textAlign: "left",
    marginLeft: 24,
    "&>p:first-child": {
      color: "#535358",
      fontSize: 14,
      width: 175,
      fontWeight: "bold",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    "&>p:last-child": {
      marginTop: -2,
      fontSize: 10,
      color: "#77838f",
    },
  },
  infoNoFileTextContainer: {
    textAlign: "left",
    marginLeft: 24,
    "&>p:first-child": {
      color: "#F8202D",
      fontSize: 14,
      fontWeight: "bold",
    },
  },
  setLoading: {
    position: "absolute",
    left: 0,
    top: 0,
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  uploadContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: 4,
  },
  textContainer: {
    marginLeft: 24,
  },
  textInfoContent: {
    fontWeight: 200,
    marginTop: 4,
    fontSize: 10,
    color: "#68758b",
  },
  hasError: {
    color: theme.palette.error.main,
  },
  helperText: {
    height: 0,
    fontSize: 14,
    fontWeight: 500,
    textAlign: "right",
    color: theme.palette.error.main,
  },
}));
